/*
This file is vanilla JS to be able to import the methods from the overwritten JS classes used for the
flipping animation.

It can be converted to TS when the overwritten JS classes are converted to TS.
 */

/**
 *
 * @param {IframeView} view
 * @returns {HTMLBodyElement|null}
 */
export const getViewBodyElement = (view) => {
  if (!view.iframe) {
    return null;
  }
  if (!view.iframe.contentDocument) {
    return null;
  }

  return view.iframe.contentDocument.querySelector('body');
};

/**
 * @param {IframeView} view
 */
export const getDiffBetweenIframeAndBodyWidth = (view) => {
  const bodyElement = getViewBodyElement(view);
  if (!bodyElement) {
    return 0;
  }

  const bodyRectangle = bodyElement.getBoundingClientRect();

  const iframeWidth = view.width();

  const offset = iframeWidth - bodyRectangle.width;

  // If for some reason the body is bigger than the iframe, we don't want to change anything.
  return Math.max(0, offset);
};
